import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Text from './Text';
import ColorProvider from './ColorProvider';

const baseStyles = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 200px;
  min-height: 25px;
  padding: 0 ${theme.spacings.kilo};
`;

const TextWrapper = styled('div')(baseStyles);

const containerBaseStyles = () => css`
  width: 100%;
`;

const Container = styled(ColorProvider)(containerBaseStyles);

const TextBar = ({ text, size, textColor, ...props }) => (
  <Container {...props}>
    <TextWrapper>
      <ColorProvider variant={textColor}>
        <Text as='span' size={size || 'mega'} noMargin>
          {text}
        </Text>
      </ColorProvider>
    </TextWrapper>
  </Container>
);

TextBar.propTypes = {
  variant: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.string,
  size: PropTypes.string,
};

TextBar.defaultProps = {
  variant: 'r500',
  cssProp: 'background',
  textColor: 'white',
};

export default TextBar;
